var render = function render(){var _vm=this,_c=_vm._self._c;return _c('labeled-status-badge',{class:`compliance-status-badge--${_vm.normalizedStatus}`,attrs:{"label":"Compliance","value":_vm.label,"variant":_vm.variant}})
}
var staticRenderFns = []

export { render, staticRenderFns }